import { GA4Event} from "./GA4Event";

export function buildUsedBookSearch(message) {
	const { attributes } = message;
	const { eventData } = new GA4Event("used_book_search", {
		search_input: attributes.search_input || '',
		interaction: attributes.interaction || '',
		currency: attributes.currency || '',
		component: attributes.component || '',
		versandbox_id: attributes.versandbox_id || '',
	});
	return eventData;
}
